<template>
  <v-container>
    <PageHeader :title="roleName" subtitle="Manage tenant permissions and settings" no-padding />
    <v-card>
      <v-card-text v-for="(section, index) in sections" :key="`section-${index}`">
        <v-subheader class="title">{{ section.name }}</v-subheader>
        <v-layout wrap class="my-3">
          <v-flex class="pa-3" v-for="(route, routeIndex) in section.routes" :key="`route-${routeIndex}`" xs12 sm6 md4 lg4>
            <TileNavigationButton :title="route.name" :to="route.to" :icon="route.icon" />
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  import PageHeader from '@/components/generic/PageHeader'
  import Subheader from '@/components/generic/Subheader'
  import TileNavigationButton from '@/components/generic/navigation/TileNavigationButton'
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const admin = createNamespacedHelpers('admin')
  export default {
    components: {
      PageHeader,
      Subheader,
      TileNavigationButton,
    },
    data() {
      return {
        roleName: this.$route.params.name,
      }
    },
    computed: {
      ...admin.mapGetters(['roleList']),
      tenantId() {
        const tenant = this.roleList.find(x => x.RoleName == this.roleName)
        return tenant && tenant.Id
      },
      sections() {
        return [{
          name: this.$t('AdministrationAccessManageEntrance.ProjectInformationDataAccess'),
          routes: [{
            name: this.$t('Button.Set_Tenant_and_Project_Names'),
            icon: 'contact_page',
            to: { name: 'fileExportDetail', params: { name: this.roleName } },
          },
          {
            name: this.$t('Button.Manage_Access'),
            icon: 'router',
            to: { name: 'roleDetail', params: { name: this.roleName } },
          },
          {
            name: this.$t('Button.Manage_Continuous_Query_Database'),
            icon: 'timeline',
            to: { name: 'continuousDataManage', params: { name: this.roleName } },
          },
          {
            name: this.$t('AdministrationAccessManageEntrance.ContinuousDataOutputManage'),
            icon: 'local_offer',
            to: { name: 'continuousDataOutputManage', params: { tenantName: this.roleName, tenantId: this.tenantId } },
          },
          ],
        },
        {
          name: this.$t('AdministrationAccessManageEntrance.FlagDatumFileSchema'),
          routes: [{
            name: this.$t('Button.Configure_Flags'),
            icon: 'flag',
            to: { name: 'flagsSysAdminManage', params: { tenant: this.roleName } },
          },
          {
            name: this.$t('Button.Manage_Depth_Height_Datums'),
            icon: 'terrain',
            to: { name: 'depthHeightDatumsSysAdminManage', params: { name: this.roleName } },
          },
          {
            name: this.$t('Button.Manage_File_Schemas'),
            icon: 'perm_media',
            to: { name: 'fileschemasmanage' },
          },
          ],

        },
        {
          name: this.$t('AdministrationAccessManageEntrance.UIConfiguration'),
          routes: [{
            name: this.$t('Button.Manage_Side_Menu'),
            icon: 'view_sidebar',
            to: { name: 'sideMenuDetail', params: { name: this.roleName } },
          },
          {
            name: this.$t('Button.Configure_Reports_Landing_Page'),
            icon: 'insert_chart',
            to: { name: 'reportVisibilityDetail', params: { name: this.roleName } },
          },
          {
            name: this.$t('Button.Configure_Station_Dashboard'),
            icon: 'satellite',
            to: { name: 'stationDashboardDetail', params: { name: this.roleName } },
          },
          {
            name: 'Map Layer',
            icon: 'pin_drop',
            to: { name: 'mapLayerManage', params: { name: this.roleName } },
          },
          {
            name: 'Static Content',
            icon: 'dashboard',
            to: { name: 'staticContentManage', params: { name: this.roleName } },
          },
          ],
        },
        ]
      },
    },
    methods: {
      goback() {
        this.$router.push('accessManage')
      },
    },
  }
</script>